import React from 'react';
import { motion } from 'framer-motion';
import { Play, Music as MusicIcon } from 'lucide-react';
export function Music() {
  return <section className="py-16 md:py-24 bg-obsidian border-y border-white/5" data-id="element-113">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-114">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 md:gap-16" data-id="element-115">
          <div className="flex-1 w-full" data-id="element-116">
            <span className="text-xs md:text-sm tracking-[0.4em] text-red-500 uppercase font-sans mb-4 block" data-id="element-117">
              Curated Atmosphere
            </span>
            <h2 className="text-4xl md:text-7xl font-serif text-white mb-8" data-id="element-118">
              Sound of <span className="text-red-500 italic" data-id="element-119">Red</span>
            </h2>
            <p className="text-white/50 font-sans leading-relaxed text-xl md:text-2xl mb-12 max-w-xl" data-id="element-120">
              The pulse of DC nightlife, curated by our resident maestros. From
              deep melodic house to timeless lounge classics.
            </p>

            <div className="space-y-6" data-id="element-121">
              {[{
              time: '22:00',
              artist: 'Resident DJ',
              set: 'Sunset Sessions'
            }, {
              time: '00:00',
              artist: 'Special Guest',
              set: 'The Crimson Hour'
            }, {
              time: '02:00',
              artist: 'After Hours',
              set: 'Deep Obsidian'
            }].map((item, i) => <div key={i} className="flex items-center gap-8 group cursor-pointer" data-id="element-122">
                  <span className="text-sm font-serif text-champagne/80" data-id="element-123">
                    {item.time}
                  </span>
                  <div className="flex-1 border-b border-white/10 pb-4 group-hover:border-champagne/30 transition-colors" data-id="element-124">
                    <h4 className="text-base uppercase tracking-widest text-white" data-id="element-125">
                      {item.artist}
                    </h4>
                    <p className="text-xs text-white/60 uppercase mt-1" data-id="element-126">
                      {item.set}
                    </p>
                  </div>
                  <Play size={16} className="text-champagne opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-127" />
                </div>)}
            </div>
          </div>

          <div className="flex-1 w-full max-w-md" data-id="element-128">
            <div className="aspect-square bg-white/5 border border-white/10 p-8 flex flex-col items-center justify-center text-center relative overflow-hidden group" data-id="element-129">
              <div className="absolute inset-0 bg-red-500/5 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-130" />
              <MusicIcon size={48} className="text-champagne mb-6" data-id="element-131" />
              <h3 className="text-2xl font-serif text-white mb-4 italic" data-id="element-132">
                The Official Playlist
              </h3>
              <p className="text-xs uppercase tracking-[0.3em] text-white/60 mb-8" data-id="element-133">
                Updated Weekly
              </p>
              <button className="bg-champagne text-obsidian px-8 py-3 text-xs md:text-sm uppercase tracking-[0.3em] font-serif hover:bg-white transition-colors" data-id="element-134">
                Listen on Spotify
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}